// removed by extract-text-webpack-plugin
module.exports = {"button":"_3bCPzEgmk4xwh4q4DjW9Wl"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/StatusEdit/style.css
 ** module id = 594
 ** module chunks = 0
 **/